import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in document.');

const tree = (
  <StrictMode>
    <App />
  </StrictMode>
);

// If the prerender step left server-rendered markup behind, hydrate it.
// Otherwise fall back to a fresh render — useful in dev (no prerender) and
// for any container that wasn't hydratable.
if (rootEl.hasChildNodes() && rootEl.firstElementChild) {
  hydrateRoot(rootEl, tree);
} else {
  createRoot(rootEl).render(tree);
}
